<template>
  <span v-for="(entries, index) in transactionString" :key="index" class="ofs-entries">
    <EntriesValue
      v-for="(entry, eIndex) in Array.isArray(entries) ? entries : []"
      :key="eIndex"
      :entry
    />
  </span>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue'

import { Transaction, TransactionSettings } from '@types'
import { OrganizeFamilyStructureTransaction } from '../utils/types'

import { getTransactionString } from '@/views/Data/Transactions/components/utils/helpers'

import EntriesValue from './EntriesValue.vue'

type Props = {
  transaction: OrganizeFamilyStructureTransaction
  transactionSettings?: TransactionSettings
}

const props = defineProps<Props>()

const nameFormatter = inject<(name: string) => string>('nameFormatter')

const transaction = computed(() => {
  return {
    id: '',
    date: '',
    type: props.transactionSettings?.name,
    description: '',
    repository_id: '',
    entries: [
      { 
        account_id: props.transaction.accountId, 
        amount: props.transaction.amount, 
        asset_id: props.transaction.assetId 
      }
    ],
  } as Transaction
})

const transactionString = computed(() => {
  return getTransactionString(transaction.value, props.transactionSettings, nameFormatter || ((id: string) => id))
})
</script>

<style scoped>
.ofs-entries {
  @apply flex flex-col sm:flex-row gap-1;
}
</style>
